import { render, staticRenderFns } from "./SGPFiltroInputBuscaComponent.vue?vue&type=template&id=e88b819c"
import script from "./SGPFiltroInputBuscaComponent.vue?vue&type=script&lang=js"
export * from "./SGPFiltroInputBuscaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports